import { AssetLocation, AssetVehicle, VehicleStatus } from "../../../../logic/api"

export const parseVehicleLocationString = (vehicleLocationString: string) => {
    const parsedVehicleLocationString = vehicleLocationString.replaceAll('/', ' ');

    return parsedVehicleLocationString;
}

export const parseKeyLocationString = (keyLocationString: string) => {
    const parsedKeyLocationString = keyLocationString.replaceAll('/', ' ');

    return parsedKeyLocationString;
}

export const parseVehicleStatus = (vehicleStatus: number) => VehicleStatus[vehicleStatus].replace(/[A-Z]/g, ' $&').trim();

export const locationDescription = (location: AssetLocation | null) => location
    ? [location.parentName, location.name].filter((x) => x).join(" / ")
    : '';

export const fullVehicleDescription = (vehicle: AssetVehicle) => `${vehicle.make} ${vehicle.model}` + (vehicle.colour ? ` (${vehicle.colour})` : ``);
